import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgGetInfoCircle = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M10 1.25a8.75 8.75 0 10.001 17.501A8.75 8.75 0 0010 1.25zm.625 12.969c0 .086-.07.156-.156.156H9.53a.157.157 0 01-.156-.156V8.906c0-.086.07-.156.156-.156h.938c.086 0 .156.07.156.156v5.313zM10 7.5a.938.938 0 010-1.875.938.938 0 010 1.875z" />
    </Icon>
  );
};

export default SvgGetInfoCircle;
